import { useLocation, Link } from "@/lib/router-compat";
import { useEffect } from "react";
import Layout from "@/components/layout/Layout";
import { Button } from "@/components/ui/button";
import { Home, Search, Phone } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <Layout>
      <div className="flex min-h-[60vh] items-center justify-center">
        <div className="text-center">
          <h1 className="font-heading text-6xl font-bold text-primary">404</h1>
          <h2 className="mt-2 font-heading text-2xl font-bold uppercase text-foreground">Oops, Page Not Found</h2>
          <p className="mt-4 text-muted-foreground">Our apologies for the inconvenience. Please try one of these links:</p>
          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <Button asChild className="font-heading uppercase">
              <Link to="/"><Home className="mr-2 h-4 w-4" />Home</Link>
            </Button>
            <Button asChild variant="outline" className="font-heading uppercase">
              <Link to="/rv-search"><Search className="mr-2 h-4 w-4" />Search RVs</Link>
            </Button>
            <Button asChild variant="outline" className="font-heading uppercase">
              <Link to="/contact-us"><Phone className="mr-2 h-4 w-4" />Contact Us</Link>
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;
